"use strict";
import axios from "axios";
import { _ } from "core-js";

//state
export var authState = {
  status_auth: "",
  uid: localStorage.getItem("uid") || "",
  pass: localStorage.getItem("pass") || "",
};

//getters
export var authGetters = {
  //funciones para optener informacion del state
  isLoggedIn: (state) => !!state.uid,
  getAuthStatus: (state) => state.status_auth,
};

//actions
export var authAcctions = {
  //logica de negocio , funciones asincronas , peticiones
  // console.log("payload :::: ",payload);

  async login(context, payload) {
    context.commit("auth_request");
    
    var headers = {
      "Content-Type":"application/json",
    };

    var req_data = {
      jsonrpc: "2.0",
      method: 'call',
      params: {
        service: "common",
        method: 'login',
        args: [axios.defaults.db, payload.user, payload.password]
      },
      id: Math.floor(Math.random() * 1000000000),      
    };

    await this._vm.$http
      .post("/jsonrpc", req_data, headers)
      .then((res) => {
        if (res.status === 200 && res.data.result) {
          localStorage.setItem("uid", res.data.result);
          localStorage.setItem("pass", payload.password);
          context.commit("auth_success", {
            uid: res.data.result,
            pass: payload.password,
          });
          return context;
        } else {
          context.commit("auth_error");
        }
      })
      .catch((err) => {
        context.commit("auth_error");
        localStorage.removeItem("uid");
        localStorage.removeItem("pass");
        return context;
      });
  },
  async logout({ commit }) {
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then((res) => {
        commit("logout");
        localStorage.removeItem("uid");
        localStorage.removeItem("pass");
        delete this._vm.$http.defaults.headers.common["uid"];
        delete this._vm.$http.defaults.headers.common["pass"];
        return "";
      })
      .catch((err) => {
        commit("auth_error");
        return err;
      });
  }
}

//mutations

export var authMutations = {
  auth_request(state) {
    state.status_auth = "loading";
  },
  auth_success(state, payload) {
    state.status_auth = "success";
    state.uid = payload.uid;
    state.pass = payload.pass;
  },
  auth_error(state) {
    state.status_auth = "error";
  },
  logout(state) {
    state.status_auth = "";
    state.uid = "";
    state.pass = "";
  },
};
